import {
    Box,
    Button,
    Container, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import '../../styles/manage.scss';
import {AddIcon as AddIconMui, TaskLoading} from "../../icons";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Profile from "../../component/tool_bar/profile";
import {
    createBoard, createForkBoard,
    deleteBoardList,
    getCaseBoardDetail,
    getCaseBoardList,
    updateBoardName
} from "../../api/boardManage";
import case1 from '../../assets/stylesCase/1.png'
import case2 from '../../assets/stylesCase/2.png'
import case3 from '../../assets/stylesCase/3.png'
import case4 from '../../assets/stylesCase/4.png'
import case5 from '../../assets/stylesCase/5.png'
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState, store} from "../../store";
import {fetchBoardListAsync} from "../../store/boardSlice";
import {deleteLocalStorage, getLocalConversionId, getLocalStorage, setLocalStorage} from "../../util/storage";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import {boardPutProps, caseBoardDetailProps, caseBoardProps, caseBoardRecords} from "../../types/board.types";
import { useTranslation } from 'react-i18next'
import {
    coverSelectCanvasImage,
    removeLoadingImage,
    setGlobalMessage,
    setSelectCanvasImage,
    setSnackbarOpen
} from "../../store/taskSlice";
import {uploadLocalImage} from "../../api/common";
import CancelIcon from "@mui/icons-material/Cancel";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { useResolvedCoverImage } from '../../hooks/useResolvedCoverImage';
import { useThemeImage } from '../../hooks/useThemeImage';
import RemoteChatBoxComponent from "../../components/RemoteChatBoxComponent";
import {generateSignature, getUserInfo} from "../../util/author";
import {setCookie} from "../../util/cookie";
import ReactMarkdown from "react-markdown";
import CloseIcon from "@mui/icons-material/Close";
import Login from "../login";
import {LoginProps} from "../../types/authority";
import {setUserInfo} from "../../store/userSlice";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import DropActive from "../../component/invitation/dropActive";
import {setDropActiveDialogOpen} from "../../store/memberSlice";
import {getRegisterEntryAbVariantFromUrl, isRegisterIntentFromUrl} from "../../util/registrationAttribution";
import BlogPanel from "./BlogPanel";
import HomeBlogPanel from "../../component/BlogPanel/HomeBlogPanel";


function BoardCoverImg({ cover, className, style }: { cover?: string | null, className?: string, style?: React.CSSProperties }) {
    const resolved = useResolvedCoverImage(cover);
    const emptyCover = useThemeImage('emptyBoardCover');
    return <img className={className} style={style} src={resolved ?? emptyCover} alt=''/>;
}

export default function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    // 案例缩略图兜底占位图（用在下面的 map 里，按 hooks 规则提到组件顶层取）
    const emptyCover = useThemeImage('emptyBoardCover');
    const [createLoading, setCreateLoading] = useState(false)

    const [openLoginDialog, setOpenLoginDialog] = useState<boolean>(false)

    const [templateType, setTemplateType] = useState<'login' | 'register' | 'code' | 'reset'>('register')

    const dispatch: AppDispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { t } = useTranslation()

    const {trackHomeRegisterClick, trackVisitorChatBoxClick, trackRegisterPopupShow, trackRegisterEntryAbExposure, trackHomeLoginClick, trackActivityPopupClick, trackShowcaseClick} = useMatomoTrackingPoint()

    const selectCanvasImage = useSelector((state: RootState) => state.task.canvasImage);
    const isClaimedDailyDrops = useSelector((state: RootState) => state.user.isClaimedDailyDrops);
    const dropActiveDialogOpen = useSelector((state: RootState) => state.member.dropActiveDialogOpen);

    const hasShownDailyDropsRef = useRef(false);
    const registerAbExposureRef = useRef<string | null>(null);

    const [page, setPage] = useState(1);
    const loadingMoreRef = useRef(false);
    const [hasMore, setHasMore] = useState(true);

    const [open, setOpen] = React.useState(false);

    const [deleteBoard, setDeleteBoard] = React.useState('')

    const [caseBoard, setCaseBoard] = React.useState<caseBoardRecords[]>([])

    const [caseBoardInfo, setCaseBoardInfo] = React.useState<caseBoardRecords | null>(null)

    const [caseBoardDetail, setCaseBoardDetail] = React.useState<caseBoardDetailProps[]>([])

    const [caseBoardDetailMainImage, setCaseBoardDetailMainImage] = React.useState<string>('')

    const [messages, setMessages] = useState<Array<{text: string, isUser: boolean}>>([]);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const inputRef = useRef<HTMLDivElement>(null);

    const [message, setMessage] = useState("");

    const handleLocalUploadClick = () => {
        fileInputRef.current?.click();
    };

    const changeDialogLoading = (open: boolean) => {
        setOpenLoginDialog(open)
    }

    const userInfo = getUserInfo()

    useEffect(() => {
        if (!userInfo) return;
        if (isClaimedDailyDrops || isClaimedDailyDrops === null) return;
        if (hasShownDailyDropsRef.current) return;
        hasShownDailyDropsRef.current = true;
        dispatch(setDropActiveDialogOpen(true))
        trackActivityPopupClick({page_id: window.location.href, switch_from: '自动弹出'})
    }, [userInfo, isClaimedDailyDrops]);

    const fetchCaseBoards = useCallback(async (pageNum = 1) => {
        // 暂时不调用useCase
       /* if (loadingMoreRef.current || !hasMore) return;

        loadingMoreRef.current = true;
        try {
            const res = await getCaseBoardList(pageNum, 20);
            if (res) {
                setCaseBoard(prev => [...(pageNum === 1 ? [] : prev), ...res.records]);
                setHasMore(res.pages > pageNum);
            }
        } finally {
            loadingMoreRef.current = false;
        }*/
    }, [hasMore]);

    useEffect(() => {
        const manageContainer = document.getElementById('manage-container');
        if (!manageContainer) return;

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = manageContainer;
            if (scrollTop + clientHeight >= scrollHeight - 100 && !loadingMoreRef.current && hasMore) {
                setPage(prev => {
                    const newPage = prev + 1;
                    fetchCaseBoards(newPage).then();
                    return newPage;
                });
            }
        };
    
     //   manageContainer.addEventListener('scroll', handleScroll);
        return () => manageContainer.removeEventListener('scroll', handleScroll);
    }, [fetchCaseBoards, hasMore]);

    const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''

    const handleClose = () => {
        setOpen(false);
        setDeleteBoard('')
    };

    const createNewForkBoard = (boardId?:string) =>{
        if (!boardId) return;
        createForkBoard(boardId).then(item => {
            if (item) changeBoard(item)
        })
    }

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            const totalLoadings = Array.from(files).map(item => 'loading');
            dispatch(setSelectCanvasImage(totalLoadings));
            try {
                const uploadPromises = Array.from(files).map(file =>
                    uploadLocalImage('current-client-id', file)
                );

                const responses = await Promise.all(uploadPromises);

                const validUrls = responses
                    .filter(res => res)
                    .map(res => (res as any).lod0);

                if (validUrls.length > 0) {
                    dispatch(removeLoadingImage(validUrls.length))
                    dispatch(setSelectCanvasImage(validUrls));
                }

            } catch (error) {
                dispatch(removeLoadingImage(files.length))
                console.error(t('upload_failed'), error);
            }
            e.target.value = '';
        }
    };

    const createNewBoard = () => {
        if (createLoading) return
        setCreateLoading(true);
        createBoard().then(item=>{
            changeBoard(item?.boardId)
            setCreateLoading(false)
            dispatch(fetchBoardListAsync())
        })
    }

    const changeBoard = (boardId?: string) => {
        setLocalStorage('boardId', boardId);
        navigate(`/?boardId=${boardId}`);
    }

    const handleSetUserInfo = (data: LoginProps | null) => {
        dispatch(setUserInfo(data))
    }

    const handleSend = () => {
        if (message.trim() || selectCanvasImage?.length) {
            const isLoading = selectCanvasImage?.find(item => item === 'loading')
            if (isLoading) {
                store.dispatch(setSnackbarOpen({open: true, message: t('uploading_images_remaining')}))
                setTimeout(()=>{
                    store.dispatch(setSnackbarOpen({open: false, message: ''}))
                }, 2000)
                return
            }
            setMessages([...messages, { text: message, isUser: true }]);
            setMessage("");

            dispatch(setGlobalMessage(message))
            createNewBoard()
        }
    };

    const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
            const textareaElement = inputRef.current?.querySelector('textarea');
            textareaElement?.blur();
        }
    }, [handleSend]);

    const openDetail = (id: number) => {

        getCaseBoardDetail(id).then(item=>{
            if(item && item.length) {
                setCaseBoardDetailMainImage(item[0].url);
                setCaseBoardDetail(item)
                setOpen(true)
            }
        })

    }

    useEffect(() => {
        if (userInfo) fetchCaseBoards(1).then()
    }, []);

    useEffect(() => {
        if (userInfo) return;
        const abVariant = getRegisterEntryAbVariantFromUrl();
        if (abVariant && registerAbExposureRef.current !== abVariant) {
            registerAbExposureRef.current = abVariant;
            trackRegisterEntryAbExposure({
                variant: abVariant,
                device_id: getLocalStorage('device_id') || undefined,
            });
        }
        if (!isRegisterIntentFromUrl()) return;
        trackRegisterPopupShow({
            register_from: abVariant === 'popup' ? 'register3_popup' : 'seo_entry',
            device_id: getLocalStorage('device_id') || undefined,
        })
        setOpenLoginDialog(true);
        setTemplateType('register');
    }, [location.search, trackRegisterEntryAbExposure, trackRegisterPopupShow, userInfo]);

    return (
        <React.Fragment>
            <Box>
                <Dialog
                    open={openLoginDialog}
                    onClose={()=>{setOpenLoginDialog(false)}}
                    aria-labelledby="alert-dialog-title"
                    fullScreen={isMobile}
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiDialog-paper': {
                            maxWidth: 'none',
                            borderRadius: isMobile ? '0px' : "20px"
                        },
                        '& .MuiDialogContent-root': {
                            padding: '0',
                        }
                    }}
                >
                    <DialogContent>
                        <div className="login-dialog-content">
                           <Login changeDialogLoading={changeDialogLoading} handleSetUserInfo={handleSetUserInfo} templateTypeProps={templateType} />
                        </div>
                    </DialogContent>
                </Dialog>
                <div className="manage-header">
                    <div></div>
                    <div className='flex-col-reverse' style={{marginRight: 10, display: userInfo ? 'flex' : 'none'}}><Profile /></div>
                    <div className="guest-actions" style={{marginRight: 10, display: !userInfo ? 'block' : 'none'}}>
                        <Button
                            variant="outlined"
                            sx={{
                                backgroundColor: 'var(--c-bg-secondary)',
                                color: 'var(--c-text-primary)',
                                borderColor: 'var(--c-text-secondary)',
                                marginRight: '10px',
                                display: 'none'
                            }}
                            onClick={()=>{
                                setOpenLoginDialog(true)
                                setTemplateType('register')
                            }}
                        >
                            登录
                        </Button>
                        <Button
                            variant="contained"
                            id='startFree'
                            sx={{
                                backgroundColor: 'var(--c-violet-soft)',
                                color: 'var(--c-on-color)',
                            }}
                            onClick={()=>{
                                trackHomeLoginClick()
                                trackRegisterPopupShow({register_from: 'home_register_button', device_id: getLocalStorage('device_id') || undefined,})
                                setOpenLoginDialog(true)
                                setTemplateType('register')
                            }}
                        >
                            免费开始
                        </Button>
                    </div>
                </div>
                <Box className='dialog'>
                    {/*<p className='label'>{t('design_prompt')}</p>*/}
                    <div className="manage-input-wrapper-glass" onClick={()=>{
                       if (!userInfo) {
                           trackRegisterPopupShow({register_from: 'home_chatbox', device_id: getLocalStorage('device_id') || undefined,})
                           setOpenLoginDialog(true)
                           setTemplateType('register')
                       }
                    }} style={{ display: "flex", justifyContent: "center", zIndex: 9}}>
                        <RemoteChatBoxComponent />
                        <div className="manage-input-wrapper" style={{backgroundColor: 'var(--c-bg)', display: 'none'}}>
                            {
                                !!selectCanvasImage?.length && <div className='imagePreview'>
                                    {
                                        selectCanvasImage?.map((item, index) => {
                                            return (
                                                <div key={index} style={{position: 'relative', width: '60px', marginLeft: "8px"}}>
                                                    {
                                                        item !== 'loading' && <div className='removeImage' onClick={() => {
                                                            const remainImage = selectCanvasImage?.filter((_, i) => i !== index);
                                                            remainImage && dispatch(coverSelectCanvasImage(remainImage))
                                                        }}><CancelIcon style={{fontSize: 18}}/></div>
                                                    }
                                                    <img src={item === 'loading' ? 'https://s1.ljcdn.com/kepler/static/dist/pages/index/img/loading.gif'
                                                        : `${process.env.REACT_APP_PROXY_TARGET}${item}`}
                                                         width='60'
                                                         height='60' style={{objectFit: 'cover'}} alt=''/>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                            <TextField
                                ref={inputRef}
                                id="outlined-multiline-static"
                                label={t('design_requirements_prompt')}
                                multiline
                                rows={5}
                                onKeyPress={handleKeyPress}
                                onChange={(e) => setMessage(e.target.value)}
                                /*onFocus={createNewBoard}*/
                                sx={{
                                    backgroundColor: 'var(--c-bg)',
                                    borderRadius: 10,
                                    width: 800,
                                }}
                            />
                            <span className="manage-add-icon" onClick={handleLocalUploadClick}>
                        <AddIconMui />
                         <input
                             type="file"
                             ref={fileInputRef}
                             onChange={handleFileChange}
                             accept="image/*"
                             multiple
                             style={{display: 'none'}}
                         />
                    </span>
                            <span onClick={handleSend}><SendIcon className="manage-send-icon" /></span>
                        </div>
                    </div>
                </Box>

                <HomeBlogPanel />


               {/* <div className="blog-panel-wrapper mobile-only">
                    <BlogPanel />
                </div>*/}


                {/*<Box sx={{display: "flex",
                    justifyContent: "space-around",
                    marginTop: '40px',
                    alignItems: "center",
                    flexWrap: 'wrap',
                    padding: '0 20px'
                }}>
                    {[{img:case1, url: 'https://www.krene.com/design/?boardId=d51ddaf9-82cc-4e47-851f-76a899e8483d&inspire=1'},
                        {img: case2, url: 'https://www.krene.com/design/?boardId=8c3607b1-2848-4d8f-8aa2-06e4657b898b&inspire=1'},
                        {img: case3, url: 'https://www.krene.com/design/?boardId=9c333232-f971-4111-8b49-cff43a3c5cf4&inspire=1'},
                        {img: case5, url: 'https://www.krene.com/design?boardId=8ee7cddf-b287-4c66-ba8d-f079a08c26ca&inspire=1'}].map((caseImg, index) => (
                        <div key={index} onClick={()=>{
                            caseImg.url && window.open(caseImg.url, '_blank');
                            const boardId = new URL(caseImg.url).searchParams.get('boardId') || '';
                            trackShowcaseClick({ page_id: window.location.href, board_id: boardId });
                        }} style={{
                            width: 'calc(50% - 20px)',
                            maxWidth: 340,
                            height: 'auto',
                            aspectRatio: '340/480',
                            backgroundImage: `url(${caseImg.img})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            marginBottom: '20px',
                        }}></div>
                    ))}
                </Box>*/}
                <Box sx={{display: 'none'}}>
                    <div className="section-title">{t('CREATE_BY_USERS')}</div>
                    <div className="board-list">
                        {
                            caseBoard.map((_, index) => (
                                <div className='borderCard' style={{width: "14rem"}} key={index} onClick={() => {
                                    openDetail(_.id)
                                    setCaseBoardInfo(_)
                                }}>
                                    <BoardCoverImg className="board-img" style={{height: '100%'}} cover={_.coverImage} />
                                </div>
                            ))
                        }
                    </div>
                </Box>
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: 'none',
                        borderRadius: "20px"
                    },
                    '& .MuiDialogContent-root': {
                        padding: '0',
                    }
                }}
            >
                <DialogContent>
                    <div className='userCaseDetail'>
                        <div className='userCaseTitle'>
                            <div className="detail-title">{caseBoardInfo?.boardName}</div>
                            <Button onClick={()=>{createNewForkBoard(caseBoardInfo?.boardId)}} variant="outlined" startIcon={<ContentPasteIcon />}>
                                {t('VIEW_BOARD')}
                            </Button>
                        </div>
                        <div className="detail-body">
                            <div className='thumbnail'>
                                {
                                    caseBoardDetail.map((item,index)=> (
                                        <img key={index} className="thumb-img" style={{borderColor: item.url === caseBoardDetailMainImage ? 'var(--c-grad)' : 'var(--c-on-color)'}} onClick={()=>{setCaseBoardDetailMainImage(item.url)}}
                                             src={ item.lod0 ? `${temporary_url}${item.lod0}` : emptyCover} alt=''/>
                                    ))
                                }
                            </div>
                            <div className='mainImage'>
                                <img src={`${temporary_url}${caseBoardDetailMainImage}`} alt='mainImage'/>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
